import { Component } from '@angular/core';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { LinksComponent } from 'app/common/components/links/links.component';
import { FooterComponent } from 'app/footer/footer.component';
import { AboutLillyComponent } from './components/about-lilly/about-lilly.component';
import { DataCardLillyComponent } from './components/data-card-lilly/data-card-lilly.component';

@Component({
  selector: 'app-lilly',
  templateUrl: './lilly.component.html',
  styleUrls: ['./lilly.component.less'],
  imports: [
    ContentCardComponent,
    ChipComponent,
    LinksComponent,
    FooterComponent,
    AboutLillyComponent,
    DataCardLillyComponent,
  ],
})
export class LillyComponent {
  Instagram = 'https://instagram.com/lovely_lilly____';
  chips = [
    'Headhunting',
    'Facility Security',
    'Cating',
    'Meow',
    'Tuna',
    'Dogsitting',
    'Cuddels',
    'Eating',
    'Zoomies',
    'Modeling',
  ];
}
